export const API_URL = "/api";

export const CACHE_API_TIME = {
  FETCH_CURRENCIES: 360
};

export const API_TIMEOUT = 30000;
